// Mock data for GGeese Studio website
import assets from './config/assets';

export const siteData = {
  companyName: "GGeese Studio",
  productName: "ArcadiaX",
  tagline: "Pioneering Immersive Mixed Reality Entertainment",
  heroTitle: "Transform Any Space Into An Epic Mixed Reality Game Center",
  heroSubtitle: "ArcadiaX is the ultimate XR gaming platform featuring drift karts, party games, and social entertainment - all in immersive mixed reality.",
  
  platformFeatures: [
    {
      id: 1,
      title: "Multi-Game Library",
      description: "From drift karting to Paint Battle, Ghost Hunt, and more - enjoy a growing library of social party games.",
      icon: "Layers"
    },
    {
      id: 2,
      title: "Mixed Reality Transformation",
      description: "Turn any empty warehouse or venue into a vibrant, interactive gaming arena with MR technology.",
      icon: "Sparkles"
    },
    {
      id: 3,
      title: "Social Gaming Experience",
      description: "4-8 players compete in real-time with spectator modes that allow friends to watch and even play along.",
      icon: "Users"
    },
    {
      id: 4,
      title: "Flexible Arena Sizes",
      description: "Compact design works in spaces from 15x15m to 20x30m. Perfect for venues, events, and entertainment centers.",
      icon: "Maximize2"
    }
  ],
  
  games: [
    {
      id: 1,
      name: "MR Drift Karting",
      description: "Race through virtual worlds while physically drifting in custom karts",
      fullDescription: "Experience the thrill of high-speed drift racing as you navigate through stunning virtual environments while physically driving our custom-built drift karts. Feel the adrenaline as you drift around corners, dodge virtual obstacles, and compete against friends in real-time multiplayer races.",
      color: "from-cyan-500 to-purple-600",
      icon: "Zap",
      features: [
        "Physical drift karts with integrated MR headsets",
        "Multiple themed race tracks (cyberpunk, fantasy, space)",
        "Real-time position tracking and collision detection",
        "Power-ups and boost pads for competitive advantage",
        "Spectator mode with live race commentary"
      ]
    },
    {
      id: 2,
      name: "Paint Battle",
      description: "Cover the arena in your team's colors in this competitive painting game",
      fullDescription: "Transform the physical arena into a vibrant canvas! Teams compete to paint the largest area with their color while driving around in karts equipped with virtual paint launchers. Strategic gameplay meets chaotic fun as you try to cover your opponents' colors while defending your own territory.",
      color: "from-pink-500 to-orange-500",
      icon: "Paintbrush",
      features: [
        "Team-based territorial control gameplay",
        "Real-time color tracking and scoring",
        "Special paint power-ups (mega splash, color shield)",
        "Dynamic arena visualization for spectators",
        "Instant replay of best moments"
      ]
    },
    {
      id: 3,
      name: "Ghost Hunt",
      description: "Hunt virtual ghosts in spooky mixed reality environments",
      fullDescription: "The arena transforms into a haunted mansion filled with mischievous ghosts! Players must work together or compete to catch the most ghosts using virtual ghost-catching equipment. Navigate through the darkened arena, spot floating spirits in your MR headset, and capture them before time runs out.",
      color: "from-purple-600 to-indigo-600",
      icon: "Ghost",
      features: [
        "Cooperative or competitive ghost hunting modes",
        "Different ghost types with unique behaviors",
        "Environmental obstacles and hiding spots",
        "Spooky audio and visual effects",
        "Leaderboard for top ghost hunters"
      ]
    },
    {
      id: 4,
      name: "Whack-a-Mole",
      description: "Classic arcade action reimagined for mixed reality karting",
      fullDescription: "The beloved arcade classic gets a high-speed makeover! Virtual moles pop up throughout the arena, and players must race to them and 'whack' them using their kart's bumper. Quick reflexes and strategic positioning are key as moles appear faster and in trickier locations as the game progresses.",
      color: "from-green-500 to-teal-500",
      icon: "Target",
      features: [
        "Fast-paced arcade action with karts",
        "Progressive difficulty levels",
        "Combo scoring for quick successive whacks",
        "Special golden moles for bonus points",
        "Time attack and endless modes"
      ]
    },
    {
      id: 5,
      name: "Holy Cows",
      description: "Team-based challenges with quirky objectives and fast-paced action",
      fullDescription: "In this hilarious team game, players must herd virtual cows through checkpoints while avoiding obstacles and interference from the opposing team. It's chaos, strategy, and laughter rolled into one as cows scatter, escape, and cause mayhem throughout the arena.",
      color: "from-yellow-500 to-orange-600",
      icon: "Trophy",
      features: [
        "Unique team-based herding mechanics",
        "Unpredictable cow AI for added challenge",
        "Strategic blocking and defensive play",
        "Multiple rounds with rotating objectives",
        "Perfect for corporate team building"
      ]
    },
    {
      id: 6,
      name: "More Games Coming",
      description: "New party games and experiences added regularly",
      fullDescription: "We're constantly developing new games and experiences for the ArcadiaX platform. From racing challenges to puzzle games, obstacle courses to battle royales - the possibilities are endless in mixed reality. Have a game idea? We'd love to hear it!",
      color: "from-slate-600 to-slate-800",
      icon: "Plus",
      features: [
        "Regular platform updates with new content",
        "Community-driven game development",
        "Custom game modes for special events",
        "Seasonal themed games and challenges",
        "Beta testing opportunities for venues"
      ]
    }
  ],
  
  technology: [
    {
      id: 1,
      title: "Meta Quest 3 Headsets",
      description: "State-of-the-art mixed reality headsets for immersive gameplay"
    },
    {
      id: 2,
      title: "Custom Drift Karts",
      description: "Specially designed karts with integrated MR systems and remote control"
    },
    {
      id: 3,
      title: "Operator Management",
      description: "Easy-to-use operator app for controlling games, scores, and player settings"
    },
    {
      id: 4,
      title: "Spectator Engagement",
      description: "Interactive spectator app allowing viewers to watch and even influence gameplay"
    }
  ],
  
  videos: [
    {
      id: 1,
      title: "ArcadiaX Platform Overview",
      description: "See how we transform spaces into mixed reality game centers",
  thumbnail: assets.videoThumbnailFallback,
      placeholder: true
    },
    {
      id: 2,
      title: "Paint Battle Gameplay",
      description: "Watch teams compete in our colorful Paint Battle game",
  thumbnail: assets.videoThumbnailFallback,
      placeholder: true
    },
    {
      id: 3,
      title: "Drift Karting in Action",
      description: "Experience the thrill of MR drift racing",
  thumbnail: assets.videoThumbnailFallback,
      placeholder: true
    }
  ],
  
  gallery: [
    {
      id: 1,
      title: "MR Headset Setup",
      url: "https://images.unsplash.com/photo-1593508512255-86ab42a8e620?w=800&q=80",
      category: "Technology"
    },
    {
      id: 2,
      title: "Drift Kart Action",
      url: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=800&q=80",
      category: "Gaming"
    },
    {
      id: 3,
      title: "Virtual Environment",
      url: "https://images.unsplash.com/photo-1535223289827-42f1e9919769?w=800&q=80",
      category: "Virtual Worlds"
    },
    {
      id: 4,
      title: "Team Competition",
      url: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800&q=80",
      category: "Social Gaming"
    },
    {
      id: 5,
      title: "Arena Setup",
      url: "https://images.unsplash.com/photo-1590859808308-3d2d9c515b1a?w=800&q=80",
      category: "Venue"
    },
    {
      id: 6,
      title: "Paint Battle Arena",
      url: "https://images.unsplash.com/photo-1618609378039-b572f64c5b42?w=800&q=80",
      category: "Gaming"
    },
    {
      id: 7,
      title: "Player Experience",
      url: "https://images.unsplash.com/photo-1552820728-8b83bb6b773f?w=800&q=80",
      category: "Social Gaming"
    },
    {
      id: 8,
      title: "XR Gaming Setup",
      url: "https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?w=800&q=80",
      category: "Technology"
    },
    {
      id: 9,
      title: "Competition Mode",
      url: "https://images.unsplash.com/photo-1534423861386-85a16f5d13fd?w=800&q=80",
      category: "Gaming"
    },
    {
      id: 10,
      title: "Futuristic Gaming",
      url: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800&q=80",
      category: "Technology"
    }
  ],
  
  useCases: [
    {
      id: 1,
      title: "Entertainment Venues",
      description: "Transform your venue into a cutting-edge XR gaming destination"
    },
    {
      id: 2,
      title: "Corporate Events",
      description: "Unforgettable team building experiences with competitive gaming"
    },
    {
      id: 3,
      title: "Private Parties",
      description: "Host birthday parties and celebrations with unique XR entertainment"
    },
    {
      id: 4,
      title: "Gaming Centers",
      description: "Add ArcadiaX to your gaming center for a next-gen attraction"
    }
  ],
  
  team: [
    {
      id: 1,
      name: "Rens Vlooswijk",
      role: "Co-Founder",
      title: "Product Vision & Business Development",
      description: "Creative entrepreneur, passionate about user experience and building the future of MR.",
  image: assets.team.rens
    },
    {
      id: 2,
      name: "Ruslan Vasilev",
      role: "Co-Founder",
      title: "Technical Lead",
      description: "Technical mastermind, always pushing the boundaries of immersive technology.",
  image: assets.team.ruslan
    }
  ],
  
  contactInfo: {
    email: "ggeesestudio@gmail.com",
    phone: "+31 6 10358097",
    address: "Brainport, Eindhoven, Netherlands",
    socialMedia: {
      twitter: "https://twitter.com/ggeesestudio",
      linkedin: "https://linkedin.com/company/ggeese-studio",
      instagram: "https://instagram.com/ggeesestudio",
      youtube: "https://youtube.com/@ggeesestudio"
    }
  }
};
